// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"09f2450a","317":"cc43a639","413":"d9312040","917":"7095900c"}[chunkId] + ".chunk.js";
};